import { useSyncExternalStore } from 'react';
import { usePageTracking } from '@/hooks/usePageTracking';
import { useClickTracking } from '@/hooks/useClickTracking';
import { useScrollDepthTracking } from '@/hooks/useScrollDepthTracking';
import { useEngagementTracking } from '@/hooks/useEngagementTracking';
import { isGA4Active, subscribeGA4Active } from '@/monitoring/ga4';

/**
 * GA4 트래킹 훅을 한곳에서 활성화하는 렌더리스 컴포넌트.
 * BrowserRouter 내부에 배치해야 useLocation을 사용할 수 있다.
 */
const ActiveGA4Tracker = () => {
  usePageTracking();
  useClickTracking();
  useScrollDepthTracking();
  useEngagementTracking();
  return null;
};

export const GA4Tracker = () => {
  const active = useSyncExternalStore(subscribeGA4Active, isGA4Active, isGA4Active);
  if (!active) return null;
  return <ActiveGA4Tracker />;
};
